export default __webpack_public_path__ + "assets/images/a9d43f9a7d80c89c45fe029bdcf95f4c.svg";